import { Route } from '@angular/router';
import { pagePermissionActivate } from '../page-permission';

/** User management under `/user/...` (default: `user/users`). */
export const userRoutes: Route = {
    path: 'user',
    data: { title: 'user' },
    children: [
        { path: '', pathMatch: 'full', redirectTo: 'users' },
        {
            path: 'users',
            loadComponent: () => import('./users/users.component').then((m) => m.UsersComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'users' },
        },
        {
            path: 'role-permission',
            loadComponent: () =>
                import('./role-permission/role-permission.component').then((m) => m.RolePermissionComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'role-permission' },
        },
        {
            path: 'invitation',
            loadComponent: () => import('./invitation/invitation.component').then((m) => m.InvitationComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'invitation' },
        },
        {
            path: 'user-type',
            loadComponent: () =>
                import('./user-types/user-types.component').then((m) => m.UserTypesComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'user-type' },
        },
        {
            path: 'engagement-category',
            loadComponent: () =>
                import('./engagement-category/engagement-category.component').then((m) => m.EngagementCategoryComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Engagement category' },
        },
        {
            path: 'engagement-category-user-deny',
            loadComponent: () =>
                import('./engagement-category-user-deny/engagement-category-user-deny.component').then(
                    (m) => m.EngagementCategoryUserDenyComponent
                ),
            canActivate: pagePermissionActivate,
            data: { title: 'Engagement category user deny' },
        },
        {
            path: 'invitation-status',
            loadComponent: () =>
                import('./invitation-status/invitation-status.component').then((m) => m.InvitationStatusComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'Invitation status' },
        },
        {
            path: 'user-role',
            loadComponent: () => import('./user-role/user-role.component').then((m) => m.UserRoleComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'User role' },
        },
        {
            path: 'user-ssomap',
            loadComponent: () => import('./user-ssomap/user-ssomap.component').then((m) => m.UserSsomapComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'User ssomap' },
        },
        {
            path: 'user-token',
            loadComponent: () => import('./user-token/user-token.component').then((m) => m.UserTokenComponent),
            canActivate: pagePermissionActivate,
            data: { title: 'User token' },
        },
    ],
};
